<template>
    <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small uk-padding-small">
            <div uk-grid>

                <div class="uk-width-1-1">
                    <h3 class="uk-heading-bullet uk-text-muted">Incomplete Applications</h3>
                    <p class="uk-text-small uk-text-muted">
                        Applicants are reminded that if they were given provisional acceptance and have not yet fulfilled the requirements for acceptance into their programmes,
                        which include meeting the standard for matriculation, be interviewed by their departments and submission of all outstanding documents, they will not be
                        given a formal acceptance letter at the New Students’ Meeting.

                        <br><br>
                        If you have any questions concerning your admissions process, please feel free to call us at the office at:
                        <br><br>
                        Phone: 1-876-963-7250-7
                        <br><br>
                        For more information contact admissions@ncu.edu.jm
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "incompleteApplications"
    }
</script>

<style scoped>

</style>